<div>
    <div class="row justify-content-center">
        <div class="col-md-8">
            <h1>Activation</h1>

            <div class="alert alert-success" *ngIf="success">
                <span><strong>Your user account has been activated.</strong> Please </span>
                <a class="alert-link" (click)="login()">sign in</a>.
            </div>

            <div class="alert alert-danger" *ngIf="error">
                <strong>Your user could not be activated.</strong> Please use the registration form to sign up.
            </div>

        </div>
    </div>
</div>
